import { recursiveConvertor } from "../utils/textConverter";
import { ILocaleObject } from "./locale.types";

export const LATIN_SR: ILocaleObject = {
  COMMON: {
    AMBALAZA: "Ambalaža",
    DRUSTVO: "Društvo",
    FILE_TYPE_PDF: "Dokument koji ste izabrali nije PDF",
    FILTER: "Filter",
    FILE_SIZE: "Dokument je veći od 20 MB",
    DOKUMENT_JE_VECI_OD: "Dokument je veći od",
    DOKUMENT_PREMASUJE_PREOSTALI_PROSTOR_OD:
      "Dokument premašuje preostali prostor od",
    PONISTI: "Poništi",
    ZATVORI: "Zatvori",
    PRETRAZI: "Pretraži",
    POZITIVNO: "Pozitivna procena",
    NEGATIVNO: "Negativna procena",
    IZABERI: "Izaberi",
    KOLONA: "Kolona",
    PLACEN: "Plaćen",
    NIJE_PLACEN: "Nije plaćen",
    PROIZVOD: "Proizvod",
    IZBRISI: "Izbriši",
    ALKOHOL: "Alkohol",
    DUVAN: "Duvan",
    KAFA: "Kafa",
    OBAVESTENJE: "Obaveštenje: ",
    DOSLO_JE_DO_GRESKE: "Došlo je do greške",
    KOD_NIJE_PRONADJEN: "Kod nije pronađen",
    ODBIJANJE_ZAHTEVA: "Odbijanje zahteva",
    ODOBRENJE_ZAHTEVA: "Odobrenje zahteva",
    ODBACIVANJE_ZAHTEVA: "Odbacivanje zahteva",
    VRACANJE_ZAHTEVA_NA_DOPUNU: "Vraćanje zahteva na dopunu",
    TIP_RESENJA_ZA_GENERISANJE: "Tip rešenja za generisanje",
    POTVRDI: "Potvrdi",
    NAZAD: "Nazad",
    ZAVRSI: "Završi",
    ODBIJ: "Odbij",
    KOMPLETAN: "Kompletan",
    GENERISANJE_RESENJA: "Generisanje rešenja",
    DA: "Da",
    NE: "Ne",
    AKCIJE: "Akcije",
    NAZIV: "Naziv",
    IME_PREZIME: "Ime i prezime",
    IME: "Ime",
    PREZIME: "Prezime",
    ULOGA: "Uloga",
    PERMISIJE: "Permisije",
    ODBACI: "Odbaci",
    IZMENI: "Izmeni",
    VRATI_NA_DOPUNU: "Vrati na dopunu",
    PRIHVATI: "Prihvati",
    STAMPAJ: "Štampaj",
    PREUZMI_ZAHTEV: "Preuzmi zahtev",
    PREUZMI_PREDRACUN: "Preuzmi predračun",
    EMAIL: "Email",
    AKTIVNO: "Aktivno",
    AKTIVAN: "Aktivan",
    NEAKTIVAN: "Neaktivan",
    SACUVAJ: "Sačuvaj",
    ULICA: "Ulica",
    BROJ: "Broj",
    GRAD: "Grad",
    POSTANSKI_BROJ: "Poštanski broj",
    JMBG: "JMBG",
    ADRESA: "Adresa",
    OZNAKA: "Oznaka",
    EAKCIZE: "eAkcize",
    ODJAVI_SE: "ODJAVI SE",
    TIP: "Tip",
    PIB: "PIB",
    MATICNI_BROJ: "Matični broj",
    TIP_OBVEZNIKA: "Tip obveznika",
    OBVEZNIK: "Obveznik",
    MINISTARTSVO_FINANSIJA: "Ministarstvo Finansija",
    DATUM: "Datum",
    ZEMLJA: "Zemlja",
    UVOZNIK: "Uvoznik",
    PROIZVODJAC: "Proizvođač",
    DODAJ_SUBJEKT: "Dodaj subjekt",
    INDEX: "Redni broj",
    IZVEZI_U_EXCEL: "Izvezi u eksel",
    IZVEZ_U: "Izvezi u",
    IZVEZI_U: "Izvezi u",
    KOLICINA: "Količina",
    NEMA_PODATAKA: "Nema podataka",
    NEMA_PODATAKA_O_TRAZENIM_AKCIZNIM_MARKICAMA:
      "Nema podataka o traženim akciznim markicama.",
    GRUPA: "Grupa",
    SUBJEKTI: "Subjekti",
    NAZIV_PODNOSIOCA: "Naziv podnosioca zahteva",
    UNESITE_IDENTIFIKATOR:
      "Unesite identifikator preduzeća koje želite da prijavite u sistem eAkcize",
    PRIVREDNO_DRUSTVO: "Privredno društvo",
    PREDUZETNIK: "Preduzetnik",
    KORISNIK_JAVNIH_SREDSTAVA: "Korisnik javnih sredstava",
    OSTALO: "Ostalo",
    PRIJAVI: "Prijavi",
    PREUZMI_VAZECE_RESENJE: "Preuzmi važeće rešenje",
    ODUZMI_DOZVOLU: "Oduzmi dozvolu",
    ODUZIMANJE_DOZVOLE_SKLADISTA: "Oduzimanje dozvole skladišta",
    PREUZMI_FORMU: "Preuzmi formu",
    PREUZMI_DOZVOLU: "Preuzmi dozvolu",
    IZDAJ_RESENJE: "Izdaj rešenje",
    LICENCE_MODAL_PORUKA:
      "Proizvođač ne može da dobije akciznu dozvolu u roku od pet godina od dana donošenja rešenja o oduzimanju akcizne dozvole",
    DOSLO_JE_DO_GRESKE_KONTAKTIRAJTE:
      "Došlo je do greške, pokušajte ponovo. Ukoliko se greška ponavlja kontaktirajte administratora!",
    JBJKS_MORA_DA_SADRZI_PET_CIFARA: "JBKJS mora da sadrži pet cifara.",
    PIB_MORA_DA_SADRZI_DEVET_CIFARA: "PIB mora da sadrži devet cifara.",
    PRIKAZI_VISE: "Prikaži više",
    PRIKAZI_MANJE: "Prikaži manje",
    MERA_JE_OBAVEZNA: "Mera i vrednost su obavezna polja.",
    VREDNOST_MORA_DA_BUDE_VECA_OD_NULE: "Vrednost mora da bude veća od nule.",
    OCISTI_FILTERE: "Očisti filtere",
    UCITAVANJE: "Učitavanje",
    POPUNITE_SVA_OBAVEZNA_POLJA: "Popunite sva obavezna polja",
  },

  NAVIGATION: {
    LISTA_IZVODA: "Lista izvoda",
    AKCIZNE_MARKICE: "Akcizne markice",
    OVLASCENA_LICA: "Ovlašćena lica",
    AKCIZNE_DOZVOLE: "Akcizne dozvole",
    NOVI_ZAHTEV: "Novi zahtev",
    LISTA_ZAHTEVA: "Lista zahteva",
    SKLADISTA: "Skladišta",
    AKCIZNA_SKLADISTA: "Akcizna skladišta",
    EVIDENCIJA_AKCIZNIH_MARKICA: "Evidencija akciznih markica",
    EVIDENCIJA_VRACENIH_MARKICA: "Evidencija vraćenih markica",
    EVIDENCIJA_ISPORUCENIH_MARKICA: "Evidencija isporučenih akciznih markica",
    LISTA_ISKORISCENIH_MARKICA: "Lista iskorišćenih akciznih markica",
    LISTA_EVIDENTIRANIH_MARKICA: "Lista evidentiranih akciznih markica",
    PERIODICNI_IZVESTAJI: "Periodični izveštaji",
    PODESAVANJA: "Podešavanja",
    REGISTAR_OBVEZNIKA: "Registar obveznika",
    PODACI_O_IZVRSENOM_UVOZU: "Podaci o izvršenom uvozu",
    QR: "Produkcioni kodovi",
    CENTRALNI_REGISTAR: "Centralni registar",
    REGISTAR_O_MARKAMA_S: "Registar o markama",
    REGISTAR_O_MARKAMA: "Registar o markama duvanskih proizvoda",
    MALOPRODAJNE_CENE: "Maloprodajne cene",
    EVIDENCIONA_LISTA_MARKAMA: "Evidenciona lista o markama",
    EVIDENCIONA_LISTA_MARKAMA_CELO:
      "Evidenciona lista o markama duvanskih proizvoda čiji se promet obavlja po posebnom postupku",
    DUVANSKI_PROIZVODI_PP: "Duvanski proizvodi PP",
    EVIDENCIONA_LISTA_TRGOVCIMA: "Evidenciona lista o trgovcima",
    EVIDENCIONA_LISTA_TRGOVCIMA_CELO:
      "Evidenciona lista o trgovcima na malo (duvanskim proizvodima)",
    REGISTAR_SUBJEKATA: "Registar subjekata",
    REGISTAR_SUBJEKATA_CELO:
      "Registar subjekata koji obavljaju promet po posebnom postupku",
    REGISTAR_TRGOVACA_S: "Registar trgovaca na veliko",
    REGISTAR_TRGOVACA: "Registar trgovaca na veliko (duvanskim proizvodima)",
    OBJEKTI_PRIVREDNIH_SUBJEKATA: "Objekti privrednih subjekata",
    REGISTAR_PROIZVODJACA_S: "Registar proizvođača",
    REGISTAR_PROIZVODJACA: "Registar proizvođača duvanskih proizvoda",
    REGISTAR_UVOZNIKA: "Registar uvoznika",
    REGISTAR_UVOZNIKA_CELO:
      "Registar uvoznika duvanskih proizvoda (duvana, obrađenog duvana, prerađenog duvana)",
    DETALJI_PERIODICNOG_IZVESTAJA: "Detalji periodičnog izveštaja",
    LISTA_PERIODICNIH_IZVESTAJA: "Lista periodičnih izveštaja",
  },

  TOAST: {
    DODALI_IZVESTAJ: "Uspešno ste dodali izveštaj!",
    IZMENILI_IZVESTAJ: "Uspešno ste izmenili izveštaj!",
    USPEH: "Uspeh",
    PREUZIMANJE: "Preuzimanje",
    PREUZMI_KODOVE: "Preuzmi kodove",
    USPESNO_GENERISAN_PERIODICNI_IZVESTAJ:
      "Uspešno generisan periodični izveštaj",
    USPESNO_REGENERISAN_PERIODICNI_IZVESTAJ:
      "Uspešno ste opozvali izgenerisan periodični izveštaj",
    GRESKA: "Greška",
    INFO: "Info",
    ACTIVATE_COMPANY_SUCCESS: "Društvo je uspešno aktivirano!",
    EDIT_USER_SUCCESS: "Korisnik je uspešno izmenjen!",
    CREATE_USER_SUCCESS: "Korisnik je uspešno kreiran!",
    EDIT_OBJECT_SUCCESS: "Objekat je uspešno izmenjen!",
    CREATE_OBJECT_SUCCESS: "Objekat je uspešno kreiran!",
    API_KEY_RENEW_SUCCESS: "API ključ uspešno obnovljen!",
    NOTIFICATION_EMAIL_CHANGE_SUCCESS:
      "Email adresa za obaveštenja je uspešno promenjena!",
    API_ON_SUCCESS: "API je uspešno uključen!",
    API_OFF_SUCCESS: "API je uspešno isključen!",
    NOTIF_ON_SUCCESS: "Notifikacije su uspešno uključene!",
    NOTIF_OFF_SUCCESS: "Notifikacije su uspešno isključene!",
    PASSWORD_NOT_MATCHING: "Unete šifre se ne podudaraju, pokušajte ponovo!",
    EVIDENTIRANJE_MARKICA_SUCCESS:
      "Podaci o markicama su uspešno evidentirani!",
    PONISTI_OPSEG_SUCCESS: "Evidentirani podaci su uspešno poništeni!",
    DOWNLOAD_SUCCESS: "Dokument je uspešno preuzet!",
    UPDATE_STAMP: "Uspešno ste podneli zahtev za akciznu markicu!",
    ODOBREN: "Zahtev za akcizne markice je odobren!",
    ODBIJ: "Zahtev za akcizne markice je odbijen!",
    ODBIJ_DOZVOLE: "Zahtev za akciznu dozvolu je odbijen!",
    ODBACEN: "Zahtev za akcizne markice je odbačen!",
    RESENJE_O_ODUZIMANJU_AKCIZNE_DOZVOLE_JE_USPESNO_IZDATO:
      "Rešenje o oduzimanju akcizne dozvole je uspešno izdato.",
    ODBACEN_DOZVOLE: "Zahtev za akciznu dozvolu je odbačen!",
    VRACEN_NA_DOPUNU: "Zahtev za akcizne markice je vraćen na dopunu!",
    VRACEN_NA_DOPUNU_DOZVOLE: "Zahtev za akciznu dozvolu je vraćen na dopunu!",
    UPDATE_QR: "Uspešno ste podneli zahtev za produkcioni kod!",
    UPDATE_LICENCE: "Uspešno ste podneli zahtev za akciznu dozvolu!",
    IZMENI_LICENCE: "Uspešno ste izmenili zahtev za akciznu dozvolu!",
    UPDATE_STATUS: "Uspešno ste promenili status zahteva za akciznu dozvolu!",
    UPDATE_STATUS_FINAL: "Zahtev je uspešno označen kao kompletan!",
    IZDAVANJE_RESENJA: "Uspešno ste izdali rešenje!",
    DODALI_OVLASCENO: "Uspešno ste dodali ovlašćeno lice!",
    IZMENILI_OVLASCENO: "Uspešno ste izmenili ovlašćeno lice!",
    UNISTENJE: "Uspešno ste promenili datum uništenja!",
    KREIRAJ_ZAHTEV: "Uspešno ste kreirali zahtev!",
    IZMENILI_ZAHTEV: "Uspešno ste izmenili zahtev!",
    POPUNITI_SVA_POLJA:
      "Da bi ste izvršili ovu akciju potrebno je popuniti sva polja!",
    USPESNO_STE_ODBILI_ZAHTEV: "Uspešno ste odbili zahtev!",
    USPESNO_STE_ODOBRILI_ZAHTEV: "Uspešno ste odobrili zahtev!",
  },

  POPCONFIRM: {
    TITLE: "Da li ste sigurni {{ text }}",
    OBNOVI_API_KLJUC:
      "da želite da obnovite API ključ? Trenutni API ključ nakon toga prestaje da bude u funkciji",
    IZBACI_IZ_PROMETA: "da želite da izabrani opseg izbacite iz prometa?",
    IZBRISI_VRACENE: "da želite da izabrani zahtev izbrišete?",
    PONISTI_OPSEG: "da želite da poništite evidentirani opseg?",
  },

  TABLES: {
    SIFRA: "Šifra",
    PLACEN: "Plaćen",
    STATUS_UPLATE: "Status uplate",
    BROJ_IZVODA: "Broj izvoda",
    POZIV_NA_BROJ: "Poziv na broj",
    IZNOS: "Iznos",
    DATUM_IZVODA: "Datum izvoda",
    UPLATILAC: "Uplatilac",
    DATUM_UNISTAVANJA: "Datum uništavanja",
    DATUM_VRACANJA: "Datum vraćanja",
    ZAM_ID_ZAHTEVA: "Zam id zahteva",
    ZAM_ID_ZAHTEVA2: "ZAM (ID zahteva)",
    ID: "Id",
    UKUPAN_BROJ_REZULTATA_PRETRAGE: "Ukupan broj rezultata pretrage",
    DRUSTVO_NAZIV: "Društvo naziv",
    DRUSTVO_PIB: "Društvo pib",
    ROBNA_MARKA: "Robna marka",
    GENERISAO_SISTEM: "Generisao sistem",
    OBJEKAT: "Objekat",
    TRAZENA_KOLICINA: "Tražena količina",
    DATUM_ZAHTEVA: "Datum zahteva",
    PODNOSILAC_ZAHTEVA: "Podnosilac zahteva",
    UPLATA_PREDRACUNA: "Uplata predračuna",
    OBVEZNIK: "Obveznik",
    NAZIV_OBVEZNIKA: "Naziv obveznika",
    BROJ_VAZECEG_RESENJA: "Broj važećeg rešenja",
    GENERISI_RESENJE: "Generiši rešenje",
    PREUZMI_RESENJE: "Preuzmi rešenje",
    DATUM_IZDAVANJA_RESENJA: "Datum izdavanja rešenja",
    DATUM_DONOSENJA_RESENJA: "Datum donošenja rešenja",
    DATUM: "Datum",
    OZNAKA_SKLADISTA: "Oznaka skladišta",
    BROJ_AKTIVNOG_RESENJA: "Broj aktivnog rešenja",
    TIP_RESENJA: "Tip rešenja",
    DATUM_VAZENJA_RESENJA: "Datum važenja rešenja",
    DATUM_RESENJA: "Datum rešenja",
    BROJ_ZAHTEVA: "Broj zahteva",
    DATUM_KREIRANJA_ZAHTEVA: "Datum kreiranja zahteva",
    TIP_ZAHTEVA: "Tip zahteva",
    BROJ_RESENJA: "Broj rešenja",
    DATUM_VAZENJA: "Datum važenja",
    STATUS: "Status",
    VRSTA_PROIZVODA: "Vrsta proizvoda",
    DOPUNI_ZAHTEV: "Dopuni zahtev",
    VIDI_DETALJE: "Vidi detalje",
    DA: "DA",
    NE: "NE",
    IME: "Ime",
    PREZIME: "Prezime",
    IME_I_PREZIME: "Ime i prezime",
    BROJ_LICNE_KARTE: "Broj lične karte",
    SIFRA_PROIZVODA: "Šifra proizvoda",
    NAZIV_MARKE_PROIZVODA: "Naziv marke proizvoda",
    NAZIV_MARKE: "Naziv marke",
    MALOPRODAJNA_CENA: "Maloprodajna cena",
    BROJ_SLUZBENOG_GLASNIKA: "Broj službenog glasnika",
    DATUM_OBJAVE: "Datum objave",
    DATUM_OD_KADA_VAZI_CENA: "Datum od kada važi cena",
    EMAIL_ADRESA: "Email adresa",
    AKTIVNO: "Aktivno",
    DATUM_VAZENJA_OVLASCENJA_OD: "Datum važenja ovlašćenja od",
    DATUM_VAZENJA_OVLASCENJA_DO: "Datum važenja ovlašćenja do",
    NAZIV_MARKE_DP: "Naziv marke d.p.",
    SIFRA_DP: "Šifra d.p.",
    REDNI_BR_IZ_REGISTRA: "Redni br. iz registra o markama po vrstama",
    JEDINICA_MERE: "Jedinica mere",
    PODACI_MARKA:
      "Podaci o privrednom subjektu koji je upisao marku d.p. u registar o markama",
    PODACI_IZVOD:
      "Podaci o privrednom subjektu kojem je dat izvod da uvozi/proizvodi registrovanu marku",
    INOSTRANI_PROIZVOD: "Inostrani proizvođač d.p. / distributer",
    ADRESA_INOSTRANOG: "Adresa inostranog proizvođača",
    PAKOVANJE: "Pakovanje",
    REDNI_BROJ_UPISA: "Redni br. upisa u evidencionu listu",
    NAZIV_ROBNE_MARKE: "Naziv robne marke",
    BROJ_POTVRDE: "Broj potvrde o upisu",
    DATUM_POTVRDE: "Datum potvrde o upisu",
    NAZIV_PRIVREDNOG_SUBJEKTA: "Naziv privrednog subjekta",
    ADRESA_PRIVREDNOG_SUBJEKTA: "Adresa privrednog subjekta",
    BROJ_RESENJA_O_UPISU: "Br. rešenja o upisu u registar",
    BROJ_RESENJA_O_UPISU_OBNOVE: "Br. rešenja o upisu/obnove upisa u registar",
    DATUM_IZADAVANJA: "Datum izdavanja",
    DATUM_OD_KADA_VAZI_RESENJE: "Datum od kada važi rešenje",
    DATUM_OD_KADA_VAZI_DOZVOLA: "Datum od kada važi dozvola",
    DATUM_DO_KADA_VAZI_DOZVOLA: "Datum do kada važi dozvola",
    BROJ_DOZVOLE: "Broj dozvole",
    NACIN_ORGANIZOVANJA: "Način organizovanja",
    NAZIV_MALOPRODAJNOG_OBJEKTA: "Naziv maloprodajnog objekta",
    ADRESA_MALOPRODAJNOG_OBJEKTA: "Adresa maloprodajnog objekta",
    ID_OBJEKTA: "ID objekta",
    NAZIV_OBJEKTA: "Naziv objekta",
    TIP_OBJEKTA: "Tip objekta",
    PODACI_O_SUBJEKTU: "Podaci o privrednom subjektu",
    PROIZVODJAC_UVOZNIK: "Proizvođač/Uvoznik",
    SIFRA_ROBNE_MARKE: "Šifra robne marke",
    VELICINA_PAKOVANJA: "Veličina pakovanja",
    BROJ_SLUZBENOG_GLASNIKA_RS: "Broj službenog glasnika RS",
    DATUM_OBJAVE_MPC: "Datum objave MPC u službenom glasniku RS",
    IZNOS_MALOPRODAJNE_CENE: "Iznos maloprodajne cene d.p.",
    DATUM_OD_CENA: "Datum od kada važi maloprodajna cena",
    OPSEG: "Opseg",
    VRSTA_KATEGORIJE: "Vrsta kategorije",
    DATUM_DO_KADA_VAZI_RESENJE: "Datum do kada važi rešenje",
    STRANI: "strani",
  },

  PLACEHOLDERS: {
    PIB_MALOPRODAJE: "PIB maloprodaje",
    DRUSTVA: "Društva",
    KOMADI: "Komadi",
    BROJ_RESENJA: "Broj rešenja",
    DATUM_VAZENJA: "Datum važenja",
    TIP_ZAHTEVA: "Tip zahteva",
    BROJ_ZAHTEVA: "Broj zahteva",
    PODNOSILAC_ZAHTEVA: "Podnosilac zahteva",
    NAZIV_OBVEZNIKA: "Naziv obveznika",
    TIP_RESENJA: "Tip rešenja",
    POVRSINA: "Površina",
    ZAPREMINA: "Zapremina",
    MERA: "Mera",
    VREDNOST_POVRSINA_ZAPREMINA: "Vrednost (površina/zapremina)",
    POVRSINA_ZAPREMINA: "Površina/Zapremina",
    ULICA: "Ulica",
    BROJ: "Broj",
    DATUM: "Datum",
    STATUS: "Status",
    MARKA: "Marka",
    DATUM_VAZENJA_OD: "Datum važenja od",
    DATUM_VAZENJA_DO: "Datum važenja do",
    MATICNI_BROJ: "Matični broj",
    PIB: "PIB",
    KATEGORIJA_MARKICE: "Kategorija markice",
    KATEGORIJE_EVIDENTIRANJA: "Kategorije evidentiranja",
    TIP_OBVEZNIKA: "Tip obveznika",
    BROJ_MARKICE: "Broj markice",
    ZAM_BROJ: "ZAM broj",
    UNESITE_DATUM_PROIZVODNJE: "Unesite datum proizvodnje",
    UNESITE_BROJ_MARKICE: "Unesite broj markice",
    UNESITE_POJEDINACNI_BROJ_MARKICE:
      "Unesite pojedinačni serijski broj akcizne markice",
    DATUM_PROIZVODNJE: "Datum proizvodnje",
    IZABERI_LOKACIJU: "Izaberite lokaciju",
    IZABERI_MASINU: "Izaberite mašinu",
    IZABERI_BREND: "Izaberite robnu marku",
    UNESI_DATUM_OD: "Unesite datum od",
    IZABERITE_DATUM: "Izaberite datum",
    IZABERITE_DATUM_OD: "Izaberite datum od",
    UNESI_DATUM_DO: "Unesite datum do",
    IZABERITE_DATUM_DO: "Izaberite datum do",
    OD: "Od",
    DATUM_OD: "Datum od",
    DATUM_DO: "Datum do",
    DO: "Do",
    BROJ_JCI: "Broj JCI",
    PIB_SPEDITERA: "PIB Špeditera",
    IZABERI_AKCIZNO_SKLADISTE: "Izaberi akcizno skladište",
    BR_MARKICE: "Broj markice",
    DATUM_EVIDENTIRANJA: "Datum evidentiranja",
    DATUM_PROIZVODNJE_PUNJENJA_ILI_DATUM_CARINJENJA:
      "Datum proizvodnje-punjenja (za proizvođače) ili datum carinjenja (za uvoznike)",
    DATUM_PROIZVODNJE_PAKOVANJA_ILI_DATUM_CARINJENJA:
      "Datum proizvodnje-pakovanja (za proizvođače) ili datum carinjenja (za uvoznike)",
  },

  LOGIN: {
    EAKCIZE: "e-Akcize",
    EAKCIZE_SERVIS: "e-akcize servis za akciznu robu",
    SERVIS_ZA_AKCIZNU_ROBU: "Servis za akciznu robu",
    DETALJNIJE: "Detaljnije",
    DETALJI: "Detalji",
    MOJE_EAKCIZE: "Moje eAkcize",
    PRIJAVA: "Prijava",
    PRIJAVA_PRO: "Prijava Pro",
    PRIJAVA_PREKO_PORTALA: "Prijava preko Portala",
    AKCIZNI_PROIZVODI: "Akcizni proizvodi",
    INFORMACIJE_O_SISTEMU: "Informacije o sistemu",
    PROPISI: "Propisi",
    PROPISI_PARAGRAPH:
      "Uvođenje sistema eAkciza propisano je Zakonom o akcizama koji je usvojen u oktobru 2023. godine, dok je način korišćenja sistema i pripadajućih modula bliže opisan u usvojenim podzakonskim aktima:",
    PROPISI_LI_1:
      "Uredba o izgledu kontrolne akcizne markice, kontrolne akcizne markice sa qr kodom, vrsti podataka na markici, načinu i postupku odobravanja i izdavanja markica, vođenja evidencije o odobrenim i izdatim markicama i obeležavanju akciznih proizvoda kontrolnim akciznim markicama, odnosno  kontrolnim akciznim markicama sa qr kodom, kao i vrstu pojedinačnog pakovanja kafe za krajnju potršnju koje se obeležava kontrolnom akciznom markicom",
    PROPISI_LI_2:
      "Uredba o uslovima, načinu i postupku registracije korisnika sistema e-akciza, sadržini i načinu preuzimanja podataka iz drugih registara koji se vode kod nadležnih organa, kao i podataka u vezi sa akciznim proizvodima, obveznicima akcize i učesnicima u prometu, postupku za upravljanje poslovnim procesima sistema e-akciza i razmeni podataka i informacija između korisnika sistema e-akcize u vezi sa akciznim proizvodima, evidentiranju, čuvanju i obradi podataka u vezi sa kretanjem akciznih proizvoda",
    PROPISI_LI_3:
      "Pravilnik o uslovima i postupku za dobijanje, obnavljanje i oduzimanje akcizne dozvole, načinu i kontroli otpremanja i dopremanja proizvoda u akcizno skladište i o vođenju evidencije u akciznom skladištu",
    AKCIZNI_PROIZVODI_PARAGRAPH:
      "Akcizni proizvodi koji će biti predmet sistema eAkciza su duvanski proizvodi, odnosno cigarete i nesagorevajući duvan, alkoholna pića i kafa.",
    INFORMACIJE_O_SISTEMU_PARAGRAPH_1:
      "Sistem elektronskih akciza (eAkcize) predstavlja centralizovanu platformu koja služi za digitalizaciju procesa koji su vezani za promet akciznih proizvoda; cigareta, nesagorevajućeg duvana, alkoholnih pića i kafe.",
    INFORMACIJE_O_SISTEMU_PARAGRAPH_2:
      "Radom na sistemu biće ubrzani procesi podnošenja zahteva za izdavanje kontrolnih akciznih markica, kao i preuzimanja istih, uz smanjenje potrebe za fizičkim odlascima u nadležne institucije sa pratećom dokumentacijom, čime će se značajno smanjiti administrativno opterećenje obveznika akcize. Takođe, obveznici će na sistemu biti odgovorni za evidentiranje iskorišćenih, neiskorišćenih i oštećenih markica, a na osnovu ovih evidencija, biće automatizovan proces popunjavanja kvartalnih izveštaja koje su obveznici dužni da podnesu Ministarstvu finansija u zakonski predviđenom roku.",
    INFORMACIJE_O_SISTEMU_PARAGRAPH_3:
      "Pored ubrzanja procesa preuzimanja akciznih markica, digitalizovaće se proces podnošenja zahteva za dobijanje, obnavljanje i ukidanje akcizne dozvole, kao i pregled važećih dozvola za akcizna skladišta, čime će se administracija i izdavanje rešenja u potpunosti vršiti putem sistema eAkciza.",
    INFORMACIJE_O_SISTEMU_PARAGRAPH_4:
      "Takođe, pored prevođenja postojećih procesa u elektronski format na sistemu eAkcize, a u skladu sa sporazumom sa Svetskom zdravstvenom organizacijom i Direktivom Evropske unije 2014/40, biće uveden i poseban modul za praćenje kretanja cigareta i nesagorevajućeg duvana kroz čitav lanac distribucije. Svi učesnici u lancu distribucije biće u obavezi da prilikom otpreme i prijema pojedinačnih i zbirnih pakovanja cigareta i nesagorevajućeg duvana u svojim objektima, izvrše skeniranje i te informacije proslede sistemu eAkciza.",
    INFORMACIJE_O_SISTEMU_PARAGRAPH_5:
      "Uvođenje ovog modela za sledljivost duvanskih proizvoda povećaće transparentnost prometa cigareta i nesagorevajućeg duvana, tako da će se za svaki proizvod znati trenutna lokacija i prethodna istorija kretanja, odnosno biće poznato kretanje svakog pojedinačnog i zbirnog pakovanja od proizvodne linije do otpremanja u prvi maloprodajni objekat. Ovo znači da će sistem eAkciza značajno doprineti u smanjenju plasmana ove tri vrste akciznih proizvoda na crno tržište, čime će se dodatno ojačati borba protiv sive ekonomije.",
    INFORMACIJE_O_SISTEMU_PARAGRAPH_6: "Korisnici sistema eAkcize su:",
    MINISTARTSVO_FINANSIJA: "Ministarstvo finansija",
    PORESKA_UPRAVA: "Poreska uprava",
    UPRAVA_CARINA: "Uprava carina",
    UPRAVA_ZA_DUVAN: "Uprava za duvan",
    NARODNA_BANKA_SRBIJE:
      "Narodna banka Srbije - Zavod za izradu novčanica i kovanog novca",
    OBVEZNICI_AKCIZE: "obveznici akcize",
    TRGOVCI_NA_VELIKO_I_NA_MALO:
      "trgovci na veliko i trgovci na malo duvanskim proizvodima",
  },

  OBVEZNIK: {
    MARKICA: "MARKICA",
    ALKOHOL_PROIZVODJAC: "Alkohol proizvođač",
    ALKOHOL_UVOZNIK: "Alkohol uvoznik",
    DUVAN_PROIZVODJAC: "Duvan proizvođač",
    DUVAN_UVOZNIK: "Duvan uvoznik",
    KAFA_PROIZVODJAC: "Kafa proizvođač",
    KAFA_UVOZNIK: "Kafa uvoznik",
  },

  AKCIZNE_MARKICE: {
    DERIVATI_NAFTE: "Derivati nafte",
    INFORMACIJE_O: "Informacije o",
    SKLADISTU: "skladištu",
    KORISNIKU: "korisniku",
    UNISTI: "Uništi",
    LISTA_ZAHTEVA_ZA_AKCIZNE_MARKICE: "Lista zahteva za akcizne markice",
    LISTA_ZAHTEVA_ZA_PERIODICNE_IZVESTAJE:
      "Lista zahteva za periodične izveštaje",
    MARKICA: "markica",
    DOZVOLA: "dozvola",
    LISTA_AKCIZNIH_MARKICA:
      "Lista zahteva za izdavanje kontrolnih akciznih markica",
    LISTA_AKCIZNIH_DOZVOLA: "Lista zahteva za akciznu dozvolu",
    NOVI_ZAHTEV: "Novi zahtev",
    DODAJ_OVLASCENO_LICE: "Dodaj ovlašćeno lice",
    IZMENI_OVLASCENO_LICE: "Izmeni ovlašćeno lice",
    IME: "Ime",
    PREZIME: "Prezime",
    BROJ_LICNE_KARTE: "Broj lične karte",
    EMAIL_ADRESA: "Email adresa",
    DATUM_VAZENJA_OVLASCENJA_OD: "Datum važenja ovlašćenja od",
    DATUM_VAZENJA_OVLASCENJA_DO: "Datum važenja ovlašćenja do",
    AKTIVNO: "Aktivno",
    NAZAD: "Nazad",
    ZAHTEV_ZA_AKCIZNU_MARKICU_JE_USPESNO_PODNET:
      "Zahtev za izdavanje kontrolne akcizne markice je uspešno podnet!",
    ZAHTEV_ZA_AKCIZNU_MARKICU_JE_USPESNO_DOPUNJEN:
      "Zahtev za izdavanje kontrolne akcizne markice je uspešno dopunjen!",
    ZAHTEV_ZA_AKCIZNU_DOZVOLU_JE_USPESNO_PODNET:
      "Zahtev za akciznu dozvolu je uspešno podnet!",
    ZAHTEV_ZA_IZMENU_AKCIZNE_DOZVOLE_JE_USPESNO_PODNET:
      "Zahtev za izmenu akcizne dozvole je uspešno podnet!",
    STAMPAJ_ZAHTEV: "Štampaj zahtev",
    PREUZMI_ZAHTEV: "Preuzmi zahtev",
    KREIRAJ_NOVI_ZAHTEV: "Kreiraj novi zahtev",
    HVALA_VAM_STO_KORISTITE_USLUGE_PORTALA_EAKCIZE:
      "Hvala Vam što koristite usluge portala eAkcize",
    OVLASCENA_LICA_ZA_PREUZIMANJE_MARKICA:
      "Ovlašćena lica za preuzimanje markica",
    UKUPAN_BROJ_REZULTATA_PRETRAGE: "Ukupan broj rezultata pretrage",
    PODACI_O_INOSTRANOM_PROIZVODJACU_ODNOSNO_DISTRIBUTERU_INOSTRANOG_PROIZVODJACA_UVOZNIK:
      "Podaci o inostranom proizvođaču, odnosno distributeru inostranog proizvođača",
    NAZIV_INOSTRANOG_PROIZVODJACA: "Naziv inostranog proizvođača",
    PORESKI_BROJ_INOSTRANOG_PROIZVODJACA: "Poreski broj inostranog proizvođača",
    ADRESA: "Adresa",
    MESTO: "Mesto",
    ADRESA_SLANJA_MARKICA: "Adresa gde se šalju markice",
    NAZIV_DISTRIBUTERA_INOSTRANOG_PROIZVODJACA:
      "Naziv distributera inostranog proizvođača",
    PORESKI_BROJ_DISTRIBUTERA_INOSTRANOG_PROIZVODJACA:
      "Poreski broj distributera inostranog proizvođača",
    PODACI_O_TRAZENIM_AKCIZNIM_MARKICAMA:
      "Podaci o traženim akciznim markicama",
    VRSTE_AKCIZNE_MARKICE: "Vrste akcizne markice",
    TRAZENE_KOLICINE: "Tražene količine",
    OZNAKA_PAKOVANJA: "Oznaka pakovanja",
    VELICINA_PAKOVANJA: "Veličina pakovanja markice",
    IZABERITE_VELICINU_PAKOVANJA_MARKICE:
      "Izaberite veličinu pakovanja markice",
    MINIMALNA_KOLICINA_ZA_IZABRANU_VELICINU_PAKOVANJA_JE:
      "Minimalna količina za izabranu veličinu pakovanja je",
    DODAJ: "Dodaj",
    IZMENI: "Izmeni",
    POSALJI_ZAHTEV: "Pošalji zahtev",
    ALKOHOL: "alkoholna pića",
    ALKOHOLNA_PICA: "Alkoholna pića",
    KAFA: "kafu",
    KAFA_VELIKO: "Кafa",
    DUVAN: "duvanske proizvode",
    DUVANSKI_PROIZVODI: "Duvanski proizvodi",
    NESAGOREVAJUCI_DUVAN: "Nesagorevajući duvan",
    CIGARETE: "Cigarete",
    GENERISI_PERIODICNI_IZVESTAJ: "Generiši periodični izveštaj",
    PONOVI_GENERISANJE_ZA_PERIOD: "Ponovi generisanje za period",
    PERIOD: "Period",
    GENERISI_PERIODICNI_IZVESTAJ_POTVRDA:
      "da želite da generišete periodični izveštaj?",
    PONOVO_GENERISI_PERIODICNI_IZVESTAJ_POTVRDA:
      "da želite da ponovo generišete periodični izveštaj?",
    ZAHTEV_ZA_AKCIZNU_MARKICU:
      "Zahtev za izdavanje kontrolnih akciznih markica za",
    ZAHTEV_ZA_AKCIZNE_MARKICE: "Zahtev za akcizne markice",
    MALOPRODAJNE_CENE: "Maloprodajne cene",
    PODACI_O_MARKAMA_PROIZVODA: "Podaci o markama proizvoda",
    TIP_PROIZVODA: "Tip proizvoda",
    TIP_OBVEZNIKA: "Tip obveznika",
    KREIRAJ_ZAHTEV: "Kreiraj zahtev",
    PODACI_O_PODNOSIOCU_ZAHTEVA: "Podaci o podnosiocu zahteva",
    NAZIV: "Naziv",
    NAZIV_OBVEZNIKA: "Naziv obveznika",
    MESTO_I_ADRESA: "Mesto i adresa",
    MESTO_SEDISTA: "Mesto sedišta",
    MATICNI_BROJ: "Matični broj",
    SIFRA_DELATNOSTI: "Šifra delatnosti",
    PRETEZNA_DELATNOST: "Pretežna delatnost",
    PIB: "PIB",
    BROJ_TEKUCEG_RACUNA: "Broj tekućeg računa",
    SPISAK_OVLASCENIH_LICA_ZA_PREUZIMANJE_MARKICA:
      "Spisak ovlašćenih lica za preuzimanje markica",
    EVIDENCIONI_BROJ: "Evidencioni broj",
    OPSEG_SERIJSKIH_BROJEVA: "Opseg serijskih brojeva (ZIN)",
    NEDOSTAJUCE_VREDNOSTI: "Nedostajuće vrednosti",
    OD: "OD",
    DO: "DO",
    PODACI_O_PORUDZBENICI: "Podaci o porudžbenici",
    BROJ_PORUDZBENICE: "Broj porudžbenice",
    ZAHTEV_ZA_IZDAVANJE_KONTROLNIH_AKCIZNIH_MARKICA:
      "Zahtev za izdavanje kontrolnih akciznih markica za ",
    NOTE: "Nije razdužena obavezna količina izdatih kontrolnih akciznih markica",
    OZNAKA_AKCIZNE_MARKICE: "Oznaka akcizne markice",
    DATUM_ISPORUKE: "Datum isporuke",
    KOLICINA_MARKICA_MORA_BITI_DELJIVA_SA_MINIMALNOM_KOLICINOM:
      "Količina markica mora biti deljiva sa minimalnom količinom",
    INFORMACIJE_O_SPECIFIKACIJI_KOLICINE_TRAZENIH_MARKICA:
      "Informacije o specifikaciji količine traženih markica",
    IZABERI_DOKUMENT: "Izaberi dokument",
    ZAMENI_DOKUMENT: "Zameni dokument",
    DOKUMENT: "Dokument",
    PREUZMI: "Preuzmi",
    UKLONI: "Ukloni",
    UPLOAD_SPECIFIKACIJE_ALKOHOL_INFO:
      "Navesti planiranu količinu markica po zapremini i procentu alkohola u gotovom proizvodu za svaku vrstu akcizne markice",
    UPLOAD_SPECIFIKACIJE_KAFA_INFO:
      "Navesti planiranu količinu markica po gramaži pakovanja kafe za svaku vrstu akcizne markice",
    DOSTIGNUT_JE_MAKSIMALNI_BROJ_KARAKTERA:
      "Dostignut je maksimalni broj karaktera.",
  },

  AKCIZNE_DOZVOLE: {
    INFORMACIJE_O_SKLADISTU: "Informacije o skladištu",
    TARIFNA_OZNAKA: "Tarifna oznaka nomenklature CT",
    PODNOSILAC_ZAHTEVA: "podnosiocu zahteva",
    MINISTARSTVO: "MINISTARSTVO",
    PORESKA: "PORESKA",
    AKCIZNO_SKLADISTE_PROIZVODNI_POGON: "Akcizno skladište-proizvodni pogon",
    KOMENTAR: "Komentar",
    ZAPISNIK: "Zapisnik",
    POTPISANO_RESENJE: "Potpisano rešenje",
    OSTALE_INFORMACIJE: "Ostale informacije",
    VREDNOST: "Vrednost",
    BROJ_I_DATUM_RESENJA_NADLEZNOG_ORGANA_U_POGLEDU_TEHNICKE_OPREMLJENOSTI:
      "Broj i datum rešenja nadležnog organa u pogledu na tehničke opremljenosti",
    LISTA_ZAHTEVA_ZA_AKCIZNE_DOZVOLE: "Lista zahteva za akcizne dozvole",
    DETALJI_DOZVOLE: "Detalji dozvole ",
    ZAHTEV_ZA: "Zahtev za",
    AKCIZNE_DOZVOLE: "akcizne dozvole",
    DOKUMENTACIJA: "Dokumentacija",
    IZJAVA_DA_LI_ISPUNJAVA_USLOVE_ZA_ELEKTRONSKU_RAZMENU_PODATAKA:
      "Izjava da li ispunjava uslove za elektronsku razmenu podataka",
    ISPUNJAVA: "Ispunjava",
    NE_ISPUNJAVA: "Ne ispunjava",
    DOKAZ_O_VLASNISTVU_ZAKUPU: "Dokaz o vlasništvu/zakupu",
    DOKAZ_O_IZVRSENOM_POPISU_AKCIZNIH_PROIZVODA:
      "Dokaz o izvršenom popisu akciznih proizvoda",
    IZVRSEN_POPIS: "Izvršen popis",
    NIJE_IZVRSEN_POPIS: "Nije izvršen popis",
    ODOBRENJE_OD_STRANE_ORGANA_NADLEZNOG_ZA_MERE_ZA_KORISCENJE_MERNOG_UREDJAJA:
      "Odobrenje od strane organa nadležnog za mere za korišćenje mernog uređaja",
    NE_VODI_SE_KRIVICNI_POSTUPAK: "Ne vodi se krivični postupak",
    POKRENUT_KRIVICNI_POSTUPAK: "Pokrenut krivični postupak",
    POSTUPAK_STECAJA_ILI_LIKVIDACIJE: "Postupak stečaja ili likvidacije",
    NIJE_POKRENUT_POSTUPAK: "Nije pokrenut postupak",
    POKRENUT_JE_POSTUPAK: "Pokrenut je postupak",
    KRIVICNI_POSTUPAK_PROTIV_ODGOVORNOG_LICA:
      "Krivični postupak protiv odgovornog lica",
    SKLADISTE: "Skladište",
    OSTVARENA_KOLICINA_PROIZVEDENIH_AKCIZNIH_PROIZVODA_U_PROTEKLOJ_KALENDARSKOJ_GODINI:
      "Ostvarena količina proizvedenih akciznih proizvoda u protekloj kalendarskoj godini",
    OSTVARENA_KOLICINA_PROIZVEDENIH_AKCIZNIH_PROIZVODA_U_PROTEKLOJ_KALENDARSKOJ_GODINI_U:
      "Ostvarena količina proizvedenih akciznih proizvoda u protekloj kalendarskoj godini u",
    OSTVARENA_KOLICINA_PROIZVEDENIH_AKCIZNIH_PROIZVODA_U_PROTEKLOJ_KALENDARSKOJ_GODINI_U_KOMADIMA:
      "Ostvarena količina proizvedenih akciznih proizvoda u protekloj kalendarskoj godini u komadima",
    PLANIRANE_KOLICINE_GODISNJE_PROIZVODNJE_AKCIZNOG_PROIZVODA:
      "Planirane količine godišnje proizvodnje akciznog proizvoda",
    PLANIRANE_KOLICINE_GODISNJE_PROIZVODNJE_AKCIZNOG_PROIZVODA_U:
      "Planirane količine godišnje proizvodnje akciznog proizvoda u",
    PLANIRANE_KOLICINE_GODISNJE_PROIZVODNJE_AKCIZNOG_PROIZVODA_U_KOMADIMA:
      "Planirane količine godišnje proizvodnje akciznog proizvoda u komadima",
    BR_SKLADISTA_ZA_KOJE_TRAZI_AKCIZNU_DOZVOLU:
      "Br. skladišta za koje traži akciznu dozvolu",
    MESTO_SKLADISTA: "Mesto skladišta",
    OZNAKA_SKLADISTA: "Oznaka skladišta",
    OPIS_AKCIZNOG_SKLADISTA: "Opis akciznog skladišta",
    OPIS_RADA_SISTEMA_RACUNOVODSTVA: "Opis rada sistema računovodstva",
    VRSTA_AKCIZNOG_PROIZVODA_KOJI_CE_SE_PROIZVODITI_I_SMESTATI_U_SKLADISTE:
      "Vrsta akciznog proizvoda koji će se proizvoditi i smeštati u skladište",
    KOLICINA_USKLADISTENIH_PROIZVODA_NA_ZALIHAMA_U_PROSTORU:
      "Količina uskladištenih proizvoda na zalihama u prostoru",
    KOLICINA_POJEDINACNIH_PAKOVANJA_U_KOMADIMA:
      "Količina pojedinačnih cigareta u komadima",
    PROSECNA_KOLICINA_POJEDINACNIH_PAKOVANJA_U_KOMADIMA:
      "Prosečna količina pojedinačnih cigareta u komadima",
    KOLICINA_POJEDINACNIH_CIGARETA_U_KOMADIMA:
      "Količina pojedinačnih cigareta u komadima",
    KOLICINA_DUVANA_U_KG: "Količina duvana u kg",
    PROSECNA_KOLICINA_DUVANA_U_KG: "Prosečna količina duvana u kg",
    PROSECAN_MESECNI_RASHOD: "Prosečan mesečni rashod",
    ADRESA_GDE_SE_OBAVLJA_PROIZVODNJA_AKCIZNOG_PROIZVODA:
      "Adresa gde se obavlja proizvodnja akciznog proizvoda",
    NACIN_OTPREMANJA_AKCIZNIH_PROIZVODA: "Način otpremanja akciznih proizvoda",
    ULICA_I_BROJ: "Ulica i broj",
    PODATAK_O_MERNIM_UREDJAJIMA: "Podatak o mernim uređajima",
    POSTANSKI_BROJ: "Poštanski broj",
    BROJ_RESENJA_NADLEZNOG_ORGANA_U_POGLEDU_TEHNICKE_OPREMLJENOSTI:
      "Broj rešenja nadležnog organa u pogledu na tehničke opremljenosti",
    MESTO: "Mesto",
    DATUM_RESENJA_NADLEZNOG_ORGANA_U_POGLEDU_TEHNICKE_OPREMLJENOSTI:
      "Datum rešenja nadležnog organa u pogledu na tehničke opremljenosti",
    NOVI_ZAHTEV_ZA_DOZVOLU: "Novi zahtev za dobijanje akcizne dozvole",
    OVU_DOZVOLU: "Ovu dozvolu",
    IZMENI: "Izmeni",
    OBNOVI: "Obnovi",
    PREKINI_VAZENJE: "Prekini važenje",
    POSALJI_ZAHTEV: "Pošalji zahtev",
    DOBIJANJE: "dobijanje",
    OBNJAVLJANJE: "obnavljanje",
    PRESTANAK: "prestanak važenja",
    IZMENU_RESENJA: "izmenu rešenja o obnavljanju",
    IZABERITE_VRSTU_AKCIZNOG_PROIZVODA: "Izaberite vrstu akciznog proizvoda",
    PROIZVODNJA_SA_SKLADISTEM: "Proizvodnja sa skladištem",
    TIP_OBJEKTA: "Tip objekta",
  },

  SKLADISTA: {
    OBNOVA_DOZVOLE: "Obnova dozvole",
    UNESITE_RAZLOG_ZA_PRESTANAK_VAZENJA_DOZVOLE_SERIJSKI_BR:
      "Unesite razlog za prestanak važenja dozvole.",
    USPESNO_STE_PODNELI_ZAHTEV_ZA_OBNOVU_DOZVOLE:
      "Uspešno ste podneli zahtev za obnovu dozvole.",
    USPESNO_STE_PODNELI_ZAHTEV_ZA_PREKID:
      "Uspešno ste podneli zahtev za prekid važenja dozvole.",
    POSALJI_ZAHTEV: "Pošalji zahtev",
    U_REDU: "U redu",
    PREGLED_VAZECEG_ZAHTEVA_SKLADISTA: "Pregled važećeg zahteva skladišta",
    ISTORIJA_ZAHTEVA: "Istorija zahteva",
    ISTORIJA_RESENJA: "Istorija rešenja",
    LISTA_SKLADISTA: "Lista skladišta",
    USPESNO_STE_IZMENILI_ZAHTEV_ZA_DOZVOLU:
      "Uspešno ste podneli zahtev za izmenu podataka.",
  },

  EVIDENCIJA_MARKICA: {
    POJEDINACNI_UNOS_TOOLTIP:
      "Za unos više vrednosti koristite zarez ili taster {{ENTER}}.",
    NOVI_ZAHTEV_VRACANJE: "Novi zahtev za vraćanje",
    IZMENI_ZAHTEV_VRACANJE: "Izmeni zahtev za vraćanje",
    GRUPA_MARKICA_BROJ: "Grupa markica broj {{ broj }}",
    UNOS_DATUMA_UNISTENJA: "Unos datuma uništenja",
    UNESI_DATUM_UNISTENJA: "Unesi datum uništenja",
    OZNAKA_VRSTE_MARKICE: "Oznaka vrste markice",
    ISKORISCENE_MARKICE: "Iskorišćene markice",
    NEISKORISCENE_MARKICE: "Neiskorišćene markice",
    OSTECENE_MARKICE: "Oštećene markice",
    OSTECENE_MARKICE_VIDLJIVE: "Oštećene markice - sa vidljivom oznakom serije",
    OSTECENE_MARKICE_NEVIDLJIVE:
      "Oštećene markice - sa nevidljivom oznakom serije",
    LOKACIJA: "Lokacija",
    MASINA: "Mašina",
    BREND: "Robna marka",
    OPSEG_OD: "Opseg od",
    OPSEG_DO: "Opseg do",
    UNOS: "Unos",
    POJEDINACNA_EVIDENCIJA: "Pojedinačna evidencija",
    ZAPREMINA_AMBALAZE_LITRI: "Zapremina ambalaže u litrima",
    KOLICINA_PAKOVANJA_KG: "Količina po pojedinačnom pakovanju u",
    ZAM_ID_ZAHTEVA: "ZAM (Broj zahteva)",
    OPSEG_SERIJSKIH_BROJEVA: "Opseg serijskih brojeva",
    BROJ_ZAM_ZAHTEVA: "Broj ZAM zahteva",
    DATUM_PROIZVODNJE_ODNOSNO_CARINJENJA:
      "Datum proizvodnje odnosno carinjenja",
    EVIDENTIRAJ_STAVLJANE_U_PROMET: "Evidentiraj stavljanje u promet",
    STAVI_U_PROMET: "Stavi u promet",
    STAVLJENO_U_PROMET_PRODAJU_INFO:
      "Za slovne oznake EC, EA i EK kolona predstavlja datum prodaje, a za proizvodnju datum stavljanja u promet.",
    STAVLJENO_U_PROMET_PRODAJU: "Stavljeno u promet / prodaju",
    PRODAJA: "Prodaja",
    DATUM_STAVLJANJA_U_PROMET: "Datum stavljanja u promet",
    DATUM_PRODAJE: "Datum prodaje",
    STAVLJENO_U_PROMET: "Stavljeno u promet",
    FILTER_U_PROMETU: "U prometu",
    FILTER_VAN_PROMETA: "Van prometa",
    FILTER_SVE: "Sve",
    EVIDENTIRANJE_OPSEGA_MARKICA:
      "Evidentiranje opsega kontrolnih akciznih markica stavljenih u promet",
    EVIDENTIRANJE_OPSEGA_MARKICA_ALKOHOL:
      "Evidentiranje stavljanja u promet akciznih markica po datumu, količini i zapremini ambalaže (L)",
    EVIDENTIRANJE_OPSEGA_MARKICA_KAFA:
      "Evidentiranje stavljanja u promet akciznih markica po datumu, količini i količini (kg) po pojedinačnom pakovanju",
    EVIDENTIRANJE_OPSEGA_MARKICA_DUVAN:
      "Evidentiranje stavljanja u promet akciznih markica po datumu i količini",
    PONISTI: "Poništi",
    POJEDINACNI_UNOS: "Pojedinačni unos",
    DATUM_EVIDENTIRANJA: "Datum evidentiranja",
    KOLICINA: "Količina",
    PO_POJEDINACNOM_PAKOVAJNU: "po pojedinačnom pakovanju",
    ZAPREMINA_AMBALAZE: "Zapremina ambalaže",
  },

  PERIODICNI_IZVESTAJI: {
    RSD: "RSD",
    NAPOMENA_KOLONA_8:
      "U kolonu 8. upisuje se stanje (broj) vraćenih oštećenih markica sa vidljivom oznakom serije.",
    NAPOMENA_KOLONA_4:
      "U kolonu 4 upisuje se podatak iz kolone 10 stanje (broj) nerazduženih akciznih markica iz prethodnog periodičnog-kvartalnog izveštaja uvećanog za stanje (broj) nerazduženih markica iz kolone 5 (prethodni kvartal).",
    NAPOMENA_KOLONA_5:
      "U kolonu 5. upisuje se broj markica kojima su obeleženi akcizni proizvodi koji se nalaze u akciznom skladištu proizvođača, kao i broj markica kojima su obeleženi akcizni proizvodi za koje ne postoji obaveza obračunavanja i plaćanja akcize - slovne oznake EC, EA i EK (član 19. Zakona o akcizama).",
    NAPOMENA_KOLONA_5_DUVAN:
      "U kolonu 5. upisuje se broj markica kojima su obeleženi akcizni proizvodi koji se nalaze u akciznom skladištu proizvođača, kao i broj markica kojima su obeleženi akcizni proizvodi za koje ne postoji obaveza obračunavanja i plaćanja akcize - slovne oznake EC, EZ, EA i EK (član 19. Zakona o akcizama).",
    NAPOMENA_ALKOHOL_7:
      "U kolonu 7. upisuje se broj markica kojima su obeležena alkoholna pića prema zapremini flaše stavljenih u promet, odnosno uvezenih, kao i prodati proizvodi obeleženi E markicama prema litraži.",
    NAPOMENA_KAFA_7:
      "U kolonu 7. upisuje se broj markica kojima je obeležena kafa prema vrsti kafe i vrsti pakovanja stavljenih u promet, odnosno uvezenih, kao i prodati proizvodi obeleženi E markicama prema gramaži.",
    NAPOMENA_KAFA_10:
      "U kolonu 10. upisuje se stanje (broj) nerazduženih markica uključujući i stanje (broj) nerazduženih markica iz kolone 5.",
    NAPOMENA_KOLONA_6:
      "U kolonu 6. upisuje se broj akciznih markica kojima su obeleženi akcizni proizvodi, posebno, po svakoj vrsti akciznog proizvoda, po kojoj se plaća akciza, koja je stavljena u promet u smislu člana 21. stav 2. Zakona o akcizama, odnosno uvezena u smislu člana 21a Zakona o akcizama, kao i prodati proizvodi obeleženi E markicom.",
    NAPOMENA_DUVAN_10:
      "U kolonu 10. upisuje se stanje (broj) nerazduženih markica uključujući i stanje (broj) nerazduženih markica iz kolone 5.",
    PERIODICNI_IZVESTAJI: "Periodični izveštaji",
    PERIOD_OD: "Period od",
    PERIOD_DO: "Period do",
    UNESITE_PIB_PRIVREDNOG_SUBJEKTA: "Unesite PIB privrednog subjekta",
    BROJ_I_DATUM_ZAMA: "Broj i datum ZAM-A",
    BROJ_I_DATUM_ZAMK: "Broj i datum ZAM/K",
    BROJ_I_DATUM_ZAMD: "Broj i datum ZAM-D",
    SLOVNA_OZNAKA_I_KOLICINA: "Slovna oznaka i količina preuzetih markica",
    SLOVNA_OZNAKA_I_KOLICINA_KAFA:
      "Oznaka (vrsta) pakovanja kafe, slovna oznaka vrste kafe i količina preuzetih markica",
    OZNAKA_SERIJE_I_SERIJSKI_BROJ:
      "Oznaka serije i serijski broj preuzetih markica od-do",
    OZNAKA_SERIJE_I_SERIJSKI_BROJ_KAFA: "Serijski broj preuzetih markica od-do",
    STANJE_NERAZDUZENIH_MARKICA:
      "Stanje (broj) nerazduženih markica iz prethodnog kvartala uključujući i stanje (broj) nerazduženih markica iz kolone 5. (prethodni kvartal)",
    BROJ_ISKORISCENIH_MARKICA_FLASA:
      "Broj iskorišćenih markica (broj proizvedenih flaša alkoholnih pića): u akciznom skladištu proizvođača i markice slovne oznake E",
    BROJ_ISKORISCENIH_MARKICA_DUVAN:
      "Broj iskorišćenih markica (broj proizvedenih paklica cigareta): u akciznom skladištu proizvođača i markice slovne oznake E",
    BROJ_ISKORISCENIH_MARKICA_KAFA:
      "Broj iskorišćenih markica (količina proizvedene kafe prema vrsti pakovanja i vrsti kafe / slovna oznaka): u akciznom skladištu proizvođača i markice slovne oznake E",
    BROJ_ISKORISCENIH_MARKICA_PROMET:
      "Broj iskorišćenih markica (broj flaša alkoholnih pića stavljenih u promet, odnosno uvezenih), kao i prodati proizvodi obeleženi E markicom",
    BROJ_ISKORISCENIH_MARKICA_PROMET_DUVAN:
      "Broj iskorišćenih markica (broj paklica cigareta stavljenih u promet, odnosno uvezenih), kao i prodati proizvodi obeleženi E markicom",
    BROJ_ISKORISCENIH_MARKICA_PROMET_KAFA:
      "Broj iskorišćenih markica (količina kafe prema vrsti kafe (slovna oznaka) i vrsti pakovanja stavljenih u promet, odnosno uvezenih), kao i prodati proizvodi obeleženi E markicom",
    ZAPREMINA_FLASE:
      "Zapremina flaše ili druge ambalaže u litrima stavljenih u promet, odnosno uvezenih, kao i prodati proizvodi obeleženi E markicama",
    NAZIV_ROBNE_MARKE_CIGARETA:
      "Naziv robne marke cigareta i MPC stavljenih u promet, odnosno uvezenih, kao i prodati proizvodi obeleženi E markicama prema robnim markama i MPC",
    KOLICINA_KAFE_PREMA_VRSTI:
      "Količina kafe prema vrsti kafe (slovna oznaka) i vrsti pakovanja stavljenih u promet, odnosno uvezenih, kao i prodati proizvodi obeleženi E markicama",
    BROJ_VRACENIH_OSTECENIH_MARKICA:
      "Broj vraćenih oštećenih markica sa vidljivom oznakom serije i serijskih brojem markica",
    BROJ_VRACENIH_OSTECENIH_MARKICA_KAFA:
      "Broj vraćenih oštećenih markica sa vidljivim serijskim brojem markica prema vrsti pakovanja kafe i vrsti kafe (slovna oznaka)",
    BROJ_VRACENIH_OSTECENIH_MARKICA_NEVIDLJIVI:
      "Broj vraćenih oštećenih markica sa nevidljivom oznakom serije i serijskim brojem markica ili potpuno uništenih markica",
    BROJ_VRACENIH_OSTECENIH_MARKICA_NEVIDLJIVI_KAFA:
      "Broj vraćenih oštećenih markica sa nevidljivom serijskim brojem markica ili potpuno uništenih markica prema vrsti pakovanja kafe i vrste kafe (slovna oznaka)",
    STANJE:
      "Stanje (broj) nerazduženih markica i serijski broj od-do na kraju kvartala, uključujući i stanje (broj) nerazduženih markica iz kolone 5",
    STANJE_KAFA:
      "Stanje (broj) nerazduženih markica i serijski broj od-do na kraju kvartala prema vrsti pakovanja kafe i vrste kafe (slovna oznaka), uključujući i stanje (broj) nerazduženih markica iz kolone 5",
    POLJE: "Polje",
    DODAJ_IZVESTAJ: "Dodaj izveštaj",
    IZMENI_IZVESTAJ: "Izmeni izveštaj",
    DATUM_I_VREME_GENERISANJA: "Datum i vreme generisanja",
  },

  QR_CODE: {
    LISTA_IZVODA_ZA_PRODUKCIONE_KODOVE: "Lista izvoda za produkcione kodove",
    ZAHTEV_ZA_GENERISANJE: "Zahtev za generisanje produkcionih kodova",
    LISTA_PRODUKCIONIH_KODOVA: "Lista produkcionih kodova",
    LISTA_ZAHTEVA_ZA_PRODUKCIONE_KODOVE: "Lista zahteva za produkcione kodove",
    OZNAKA_JESU_LI_U_PROCES_PROIZVODNJE_UKLJUCENE_MASINE:
      "Oznaka jesu li u proces proizvodnje uključene mašine",
    IDENTIFIKACIJSKI_KOD_MASINE: "Identifikacijski kod mašine",
    VRSTA_DUVANSKOG_PROIZVODA: "Vrsta duvanskog proizvoda",
    OZNAKA_KOMBINOVANE_NOMENKLATURE_KN_CARINSKA_TARIFA:
      "Oznaka kombinovane nomenklature KN - carinska tarifa",
    ROBNA_MARKA_DUVANSOG_PROIZVODA: "Robna marka duvanskog proizvoda",
    PROSECNA_BRUTOMASA_JEDINICNOG_PAKOVANJA_UKLJUCUJUCI_PAKOVANJE:
      "Prosečna bruto masa jediničnog pakovanja, uključujući pakovanje, u gramima sa tačnošću do 0,1 grama",
    PROSECNA_BRUTO_MASA_JEDINICNOG_PAKOVANJA:
      "Prosečna bruto masa jediničnog pakovanja",
    BROJ_CIGARETA_U_JEDINICNOM_PAKOVANJU:
      "Broj cigareta u jediničnom pakovanju",
    TRAZENA_KOLICINA_JEDINSTVENIH_OZNAKA:
      "Tražena količina jedinstvenih identifikacijskih oznaka na nivou jediničnog pakovanja",
    TIP_OBVEZNIKA_JE_OBAVEZAN: "Tip obveznika je obavezan.",
    OBJEKAT_JE_OBAVEZAN: "Objekat je obavezan.",
    OZNAKA_JE_OBAVEZNA: "Oznaka je obavezna.",
    VRSTA_DUVANSKOG_PROIZVODA_JE_OBAVEZNA:
      "Vrsta duvanskog proizvoda je obavezna.",
    ROBNA_MARKA_JE_OBAVEZNA: "Robna marka je obavezna.",
    BRUTO_MASA_JE_OBAVEZNA: "Bruto masa je obavezna.",
    BROJ_CIGARETA_JE_OBAVEZAN: "Broj cigareta je obavezan.",
    TRAZENA_KOLICINA_JE_OBAVEZNA: "Tražena količina je obavezna.",
    MINIMALNA_KOLICINA_ZA_PORUCIVANJE_JE_1000:
      "Minimalna količina za poručivanje je 1000.",
    MAKSIMALNA_KOLICINA_ZA_PORUCIVANJE_JE_1_000_000:
      "Maksimalna količina za poručivanje je 1000000.",
    IZABERITE_OBJEKAT: "Izaberite objekat",
    IZABERITE_MASINU: "Izaberite mašinu",
    ZA_IZBOR_MASINE_PRVO_ODABERITE_OBJEKAT:
      "Za izbor mašine, prvo odaberite objekat",
    NAZAD_NA_LISTU_ZAHTEVA: "Nazad na listu zahteva",
    ODOBRI_ZAHTEV: "Odobri zahtev",
    ODBIJ_ZAHTEV: "Odbij zahtev",
  },

  TRACK: {
    PIB: "PIB",
    POSLATO: "Poslato",
    PRIMLJENO: "Primljeno",
    POVRAT: "Povrat",
    UNISTENO: "Uništeno",
    UKUPNA_KOLICINA: "Ukupna količina",
    NAZIV_PRIVREDNOG_SUBJEKTA: "Naziv privrednog subjekta",
    STANJE_NA_ZALIHAM: "Stanje na zalihama",
    NAZIV_MALOPRODAJE: "Naziv maloprodaje",
    IME: "Ime",
    PIB_MALOPRODAJE: "PIB maloprodaje",
    PROIZVODNJA: "Proizvodnja",
    UVOZ: "Uvoz",
    VELETRGOVINA: "Veletrgovina",
    PRIJEM_POVRAT: "Prijem povrat",
    SLANJE_POVRAT: "Slanje povrat",
    PRIJEM: "Prijem",
    SLANJE: "Slanje",
    SALJE: "Šalje",
    PRIMA: "Prima",
    OTPREMNICA: "Otpremnica",
    BROJ_OTPREMNICE: "Broj otpremnice",
    STATUS_OTPREMNICE: "Status otpremnice",
    TIP_PAKOVANJA: "Tip pakovanja",
    IDENTIFIKACIONI_KOD_PAKOVANJA: "Identifikacioni kod pakovanja",
    IDENTIFIKACIONI_KOD: "Identifikacioni kod",
    OBJEKAT: "Objekat",
    OBJEKAT_DRUSTVA: "Objekat društva",
    OBJEKAT_SALJE: "Objekat koji prima",
    OBJEKAT_SALJE_T: "Objekat na koji se šalje",
    IZVESTAJI_O_PROMETU: "Izveštaji o prometu",
    DATUM_I_VREME: "Datum i vreme",
    OPOZIV_SLANJE: "Slanje (Opoziv)",
    OPOZIV: "Opoziv",
    PALETA: "Paleta",
    BOKS: "Boks",
    KODOVI: "Kodovi",
    DRUSTVO_PRIJEM: "Društvo koje prima",
    DRUSTVO_SLANJE: "Društvo na koje se šalje",
    OBJEKAT_KOJI_S: "Objekat koji šalje",
    NAPOMENA: "Napomena",
    PRETOVAR: "Pretovar",
    VOZILO_SLANJE: "Vozilo slanje",
    VOZILO: "Vozilo",
    DETALJI: "Detalji",
    DATUM_VREME: "Datum i vreme",
    DATUM: "Datum",
    TIP: "Tip",
    KOD: "Kod",
    PAKOVANJE_TIP: "Pakovanje tip",
    KOLICINA: "Količina",
    PRACENJE: "Praćenje",
    PRACENJE_KODOVA: "Praćenje produkcionih kodova",
    NAZIV_DRUSTVA: "Naziv društva",
    MARKA: "Marka",
    SASTAV: "Sastav",
    ISTORIJA: "Istorija",
    ISTORIJA_KODOVA: "Istorija produkcionih kodova",
    SIFRA_MARKE: "Šifra marke",
    ZBIRNO_PAKOVANJE: "Zbirno pakovanje",
    UPAKOVANO_U: "Upakovano u",
    BREND_SIFRA: "Robna marka šifra",
    BREND_NAZIV: "Robna marka naziv",
    SERIJSKI_BROJ_MASINE: "Serijski broj mašine",
    MODEL_MASINE: "Model mašine",
    PROIZVODJAC_MASINE: "Proizvođač mašine",
    BROJ_CIGARETA: "Broj cigareta u pojedinačnom pakovanju",
    PLANIRANO_VREME_ISPORUKE: "Planirano vreme isporuke",
    MONITORING: "Monitoring",
    NAZIV_DRUSTVA_NA_KOJE_SE_SALJE: "Naziv društva na koje se šalje",
    PIB_DRUSTVA_NA_KOJE_SE_SALJE: "PIB društva na koje se šalje",
    OBJEKAT_DRUSTVA_NA_KOJE_SE_SALJE: "Objekat društva na koje se šalje",
    ID_SLANJA: "ID slanja",
    PIB_DRUSTVA: "PIB društva",
    INFORMACIJA_O_SLANJU: "Informacije o slanju",
    KVANTITATIVNI_PRIJEM_E_OTPREMNICE: "Kvantitativni prijem eOtpremnice",
    ADRESA_ODREDISTA: "Adresa odredišta",
    ADRESA_OTPREME: "Adresa otpreme",
    INFORMACIJE_E_OTPREMNICE: "Informacije eOtpremnice",
    INFORMACIJE_O_PRIJEMU: "Informacije o prijemu",
    PLANIRANO_VREME_OTPREME: "Planirano vreme otpreme",
    VREME_FIZICKOG_PRIJEMA: "Vreme fizičkog prijema",
    ID_OTPREMNICE: "ID Otpremnice",
    DOGADJAJ_NEUPARIVANJA: "Događaj neuparivanja",
  },

  SETTINGS_COMPANY: {
    DETALJI_KOMPANIJE: "Detalji kompanije",
    KONTAKT: "Kontakt",
    OBJEKTI: "Objekti",
    KORISNICI: "Korisnici",
    API: "API",
    NAZAD: "Nazad",
    POSALJI_ZAHTEV: "Pošalji zahtev",
    EVIDENTIRAJ: "Evidentiraj",
    NAZIV: "Naziv",
    TIP_KORISNIKA: "Tip korisnika",
    E_POSTA: "Elektronska pošta",
    ULICA_BROJ: "Ulica i broj",
    SACUVAJ: "Sačuvaj",
    JBKJS: "JBKJS",
    PIB: "PIB",
    GRAD: "Grad",
    POSTANSKI_BROJ: "Poštanski broj",
    DRZAVA: "Država",
    TELEFON: "Telefon",
    BROJ_TEKUCEG_RACUNA: "Broj tekućeg računa",
    KONTAKT_OSOBA: "Kontakt osoba",
  },

  SETTINGS_USERS: {
    NOVI_KORISNIK: "Novi korisnik",
    VAZI_OD: "Važi od",
    VAZI_DO: "Važi do",
  },

  SETTINGS_OBJECTS: {
    ID_MASINE: "ID mašine",
    NAZIV: "Naziv",
    ULICA_BROJ: "Ulica i broj",
    GRAD_POSTANSKI_BROJ: "Grad i poštanski br.",
    NOVI_OBJEKAT: "Novi objekat",
    NOVA_ADRESA: "Nova adresa",
    ODGOVORNO_LICE: "Odgovorno lice",
    MASINE: "Mašine",
    MASINA_BR: "Mašina {{ br }}",
    TIP_VOZILA: "Tip vozila",
    CARINSKO_SKLADISTE: "Carinsko skladište",
    AKCIZNO_SKLADISTE: "Akcizno skladište",
    SKLADISTE: "Skladište",
    NAZIV_SKLADISTA: "Naziv skladišta",
    MODEL: "Model",
    PROIZVODJAC: "Proizvođač",
    SERIJSKI_BR: "Serijski br.",
    KAPACITET: "Kapacitet",
    OZNAKA_VOZILA: "Oznaka vozila",
    NAJVECI_KAPACITET:
      "Najveći kapacitet u proizvodnom ciklusu od 24h izražen u jediničnim pakovanjima",
  },

  SETTINGS_API: {
    API_PODESAVANJA: "API podešavanja",
    API_LINK: "Link za API",
    AUTH_KEY: "Ključ za autentifikaciju",
    OBNOVI: "Obnovi",
    API_STATUS: "API status",
    API_ENDPOINT: "Novi objekat",
    ADRESA_ZA_NOTIFIKACIJE: "Email adresa za prijem notifikacija",
    NOTIFIKACIJE: "Isključi notifikacije na e-pošti",
  },

  REGISTRI: {
    REGISTAR_OBVEZNIKA: "Registar obveznika",
    NAZIV_PRIVREDNOG_SUBJEKTA: "Naziv privrednog subjekta: {{ naziv }}",
    ADRESA_PRIVREDNOG_SUBJEKTA: "Adresa privrednog subjekta: {{ adresa }}",
    PIB: "PIB: {{ pib }}",
    MATICNI_BR: "Matični br.: {{ maticniBr }}",
    TIP_DOZVOLE: "Tip dozvole",
    BROJ_RESENJA: "Broj rešenja",
    DATUM_RESENJA: "Datum rešenja",
    DATUM_UPISA: "Datum upisa",
    DATUM_ISPISA: "Datum ispisa",
  },

  PU_OBRASCI: {
    BROJ_JCI: "Broj JCI",
    PIB_SPEDITERA: "PIB Špeditera",
    SEKCIJA: "Sekcija",
    OPSTI_PODACI: "Opšti podaci",
    PODACI_O_UVOZNIKU: "Podaci o uvozniku",
    PODACI_O_IZVOZNIKU: "Podaci o izvozniku",
    PODACI_O_SPEDITERU: "Podaci o špediteru",
    PODACI_O_PREVOZNOM_SREDSTVU: "Podaci o prevoznom sredstvu u prispeću",
    PODACI_O_UVEZENOJ_ROBI: "Podaci o uvezenoj robi",
    DATUM_CARINJENJA: "Datum carinjenja",
    SIFRA_CARINSKE_ISPOSTAVE: "Šifra carinske ispostave",
    NAZIV_I_ADRESA: "Naziv i adresa",
    NAZIV: "Naziv",
    PIB: "PIB",
    ZEMLJA: "Zemlja",
    IDENTITET_PREVOZNOG_SREDSTVA: "Identitet prevoznog sredstva u prispeću",
    REDNI_BROJ: "Redni broj",
    PAKOVANJE_NAIMENOVANJE: "Pakovanje i naimenovanje, oznake i brojevi",
    PODACI_O_IZVRSENOM_UVOZU: "Podaci o izvršenom uvozu robe",
  },

  ZAM_PUBLIC: {
    PODACI_O_ARTIKLU: "Podaci o artiklu",
    SERIJSKI_BROJ_AM: "Serijski broj akcizne markice",
    TIP_PROIZVODA: "Tip proizvoda",
    NAZIV_BRENDA: "Naziv robne marke ",
    MESTO_PROIZVODNJE: "Mesto proizvodnje",
    PROIZVODNA_LINIJA: "Proizvodna linija",
    TRZISTE: "Tržište ",
    DATUM_PROIZVODNJE: "Datum proizvodnje",
    PROIZVODJAC: "Proizvođač",
    UVOZNIK: "Uvoznik",
    PROIZVODJAC_UVOZNIK: "Proizvođač/Uvoznik",
    GENERIC_ERROR: "Došlo je do greške, molimo pokušajte ponovo",
    DATUM_PROIZVODNJE_CARINJENJA: "Datum proizvodnje odnosno carinjenja",
    AMBALAZA: "Ambalaža",
    PIB: "PIB",
  },

  ANTD: {
    NED: "Ned",
    PON: "Pon",
    UTO: "Uto",
    SRE: "Sre",
    CET: "Čet",
    PET: "Pet",
    SUB: "Sub",
    JAN: "Jan",
    FEB: "Feb",
    MAR: "Mar",
    APR: "Apr",
    MAJ: "Maj",
    JUN: "Jun",
    JUL: "Jul",
    AVG: "Avg",
    SEP: "Sep",
    OKT: "Okt",
    NOV: "Nov",
    DEC: "Dec",
  },

  BANNERS: {
    ZAKON_O_ALKOHOLNIM_PROIZVODIMA: "Zakon o alkoholnim proizvodima",
    ZAKON_O_DUVANSKIM_PROIZVODIMA: "Zakon o duvanskim proizvodima",
    ZAKON_O_KAFENIM_PROIZVODIMA: "Zakon o kafenim proizvodima",
    VIDI_JOS: "Vidi još",
  },

  MAINTENANCE: {
    TITLE: "Trenutno se vrši ažuriranje sistema.",
    SUB_TITLE:
      "Očekujemo da ćemo se uskoro vratiti s novim i poboljšanim sadržajem. Hvala vam na razumevanju!",
  },
};

export const LATIN_CONVERTED_CYRILIC = recursiveConvertor(
  LATIN_SR as any,
  "lat-cir"
);
